import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const Alert = withReactContent(Swal);

export default Alert.mixin({
  confirmButtonText: '確定',
  cancelButtonText: '取消',
  confirmButtonClass: 'alert-button alert-confirm-button',
  cancelButtonClass: 'alert-button alert-cancel-button',
  inputClass: 'alert-input',
  customClass: 'alert',
  buttonsStyling: false,
  showCloseButton: true,
  allowOutsideClick: () => !Alert.isLoading(),
  width: 340,
  padding: 15,
});



// WEBPACK FOOTER //
// ../pos-master/packages/pos-components/src/Alert/Alert.jsx